import { Socket } from 'sharedb/lib/sharedb';

export class ShareDBSocket implements Socket {
  private ws: WebSocket;

  private callbacks: {
    message: ((event: MessageEvent) => void)[];
    close: ((event: CloseEvent) => void)[];
    error: ((event: Event) => void)[];
    open: ((event: Event) => void)[];
  };

  constructor(...args: ConstructorParameters<typeof WebSocket>) {
    this.ws = new WebSocket(...args);

    this.callbacks = {
      message: [],
      close: [],
      error: [],
      open: [],
    };
  }

  get readyState(): number {
    return this.ws.readyState;
  }

  private removeAllListeners() {
    for (const cb of this.callbacks.message) {
      this.ws.removeEventListener('message', cb);
    }
    for (const cb of this.callbacks.close) {
      this.ws.removeEventListener('close', cb);
    }
    for (const cb of this.callbacks.error) {
      this.ws.removeEventListener('error', cb);
    }
    for (const cb of this.callbacks.open) {
      this.ws.removeEventListener('open', cb);
    }
  }

  close(...args: Parameters<WebSocket['close']>): void {
    this.ws.close(...args);

    this.removeAllListeners();
  }

  send(...args: Parameters<WebSocket['send']>): void {
    this.ws.send(...args);
  }

  set onmessage(callback: (event: MessageEvent) => void) {
    this.callbacks.message.push(callback);
    this.ws.addEventListener('message', callback);
  }

  set onclose(callback: (event: CloseEvent) => void) {
    this.callbacks.close.push(callback);
    this.ws.addEventListener('close', callback);
  }

  set onerror(callback: (event: Event) => void) {
    this.callbacks.error.push(callback);
    this.ws.addEventListener('error', callback);
  }

  set onopen(callback: (event: Event) => void) {
    this.callbacks.open.push(callback);
    this.ws.addEventListener('open', callback);
  }
}
